import React from 'react';

import { Draggable } from '../DragAndDrop/Draggable';
import { dataHooks } from './constants';

export default Component => {
  const withDNDContext = props => (
    <div data-hook={props.dataHook}>
      <Draggable.Manager dataHook={dataHooks.provider}>
        <Component {...props} />
      </Draggable.Manager>
    </div>
  );

  withDNDContext.displayName = Component.displayName;

  return withDNDContext;
};
